// @flow

import window from 'window';

import { TABS_KEYS } from '../pages/insured/constants';
import { SOURCE_PARAM, SOURCE_PARAM_KEY } from '../pages/insured/constants/telemed';

import type { StatisticsQueriesInterface } from 'server2';

const getStatisticsQueries = (): StatisticsQueriesInterface => {
	// const source = window.location.hash.includes(TABS_KEYS.SYMPTOM_CHECKER); // No more separated tab for Symptom checker, it migrated to telemed-hub
	const source = window.location.hash.includes(TABS_KEYS.TELEMED_HUB);
	const queryString = window.location.search;
	// eslint-disable-next-line no-undef
	const urlParams = new URLSearchParams(queryString);
	const rgstmSourceParam = urlParams.get(SOURCE_PARAM_KEY);

	// eslint-disable-next-line max-len
	return (source || rgstmSourceParam) ? {[SOURCE_PARAM_KEY]: source ? SOURCE_PARAM : rgstmSourceParam} : {};
};

export {
	getStatisticsQueries,
};
